import InvitationsListContainer from './invitations_list_container';

const InvitationsList = InvitationsListContainer;

export default InvitationsList;
